import React from 'react';
import Container from 'legacy/common/components/layout/Container';

const OfferLoadingSkeleton: React.FC = () => (
  <Container>
    <div className="animate-pulse pt-[90px] md:pt-[180px] -mt-[90px] pb-20 md:w-[630px] md:mx-auto">
      <div className="flex flex-col space-y-2 w-full">
        <div className="h-8 bg-gray-200 rounded w-1/6" />
        <div className="h-12 bg-gray-200 rounded w-5/6 rounded-xl" />
      </div>

      <div className="flex flex-col space-y-2 w-full mt-8">
        <div className="h-8 bg-gray-200 rounded w-1/6" />
        <div className="h-5 bg-gray-200 rounded w-3/6" />
        <div className="flex flex-row w-full">
          <div className="h-12 bg-gray-200 rounded w-1/6 mr-2 rounded-xl" />
          <div className="h-12 bg-gray-200 rounded w-3/6 mr-2 rounded-xl" />
          <div className="h-12 bg-gray-200 rounded w-1/6 mr-2 rounded-xl" />
        </div>
      </div>

      <div className="flex flex-col space-y-2 w-full mt-8">
        <div className="h-8 bg-gray-200 rounded w-1/6" />
        <div className="h-12 bg-gray-200 rounded w-5/6 rounded-xl" />
      </div>

      <div className="flex flex-col space-y-2 w-full mt-8">
        <div className="h-8 bg-gray-200 rounded w-1/6" />
        <div className="h-5 bg-gray-200 rounded w-3/6" />
        <div className="h-12 bg-gray-200 rounded w-5/6 rounded-xl" />
      </div>

      <div className="flex flex-col space-y-2 w-full mt-8">
        <div className="h-8 bg-gray-200 rounded w-1/6" />
        <div className="h-12 bg-gray-200 rounded w-5/6 rounded-xl" />
        <div className="h-12 bg-gray-200 rounded w-5/6 rounded-xl" />
        <div className="h-5 bg-gray-200 rounded w-2/6" />
      </div>
      <div className="mt-2 text-2xl flex items-center col-span-3 h-px bg-gray-200" />
      <div className="h-5 bg-gray-200 rounded w-2/6 mt-2" />

      <div className="h-5 bg-gray-200 rounded w-2/6 mt-8" />
    </div>
  </Container>
);

export default OfferLoadingSkeleton;
